import dayjs from 'dayjs';
import { Col, Content, Row, Button, Alert, Divider, Colors, TextInput2, Tooltip, TextDateInput2, Div } from '@gower/react-ui/components';
import { useStore } from '../store';
import { useUserLicense } from 'features/hooks/useUserLincese';
import { MdOutlineHelpOutline } from '@gower/react-ui/icons';
import { Loader } from '@gower/react-ui/template/loader';

export const PayoutInvoicesMobile = () => {

    const store = useStore();
    const { license } = useUserLicense();

    if ( store.ready.isLoading )
        return <>
            <Content columns justifyCenter>
                <Col center>
                    <Loader
                        status={store.ready}
                        loadingTitle=""
                    />
                </Col>
            </Content>
        </>;

    return <>
        <Content columns color="white" scrollOnlyVertical>
            <Col padding={5} white>
                <Content columns justifyCenter gap={10}>

                    <Col gutter center fullWidth maxWidth={800} show={Boolean( store.message )}>
                        <Div
                            fullWidth
                            padding={20}
                            color="blue-6"
                            textWhite
                            rounded
                        >
                            <Div html={store.message.replace( /(?:\\[r]|[\r])/g, "</br>" )} />
                        </Div>
                    </Col>

                    <Col center borderRadius={5} fullWidth maxWidth={800} padding={20}>
                        <Row columns>
                            <Col height={30} />
                            <Col gutter>
                                <TextInput2
                                    label="Matrícula"
                                    value={license}
                                    readOnly
                                    contentRight={(
                                        <Col center paddingX={5} paddingTop={5}>
                                            <Tooltip title="La matrícula no puede editarse">
                                                <MdOutlineHelpOutline size={20} color={Colors['primary']} />
                                            </Tooltip>
                                        </Col>
                                    )}
                                />
                            </Col>
                            <Col gutter>
                                <TextDateInput2
                                    label="Desde fecha"
                                    value={store.startDate}
                                    onChangeValue={( v ) => store.startDate = v}
                                    contentRight={(
                                        <Col center>
                                            <Button text bold label="Hoy" onClick={() => store.startDate = dayjs()} />
                                        </Col>
                                    )}
                                />
                            </Col>
                            <Col gutter>
                                <TextDateInput2
                                    label="Hasta fecha"
                                    value={store.endDate}
                                    onChangeValue={( v ) => store.endDate = v}
                                    contentRight={(
                                        <Col center>
                                            <Button text bold label="Hoy" onClick={() => store.endDate = dayjs()} />
                                        </Col>
                                    )}
                                />
                            </Col>

                            <Col height={30} />
                            <Divider marginY={12} show={store.Status.isOk} />

                            <Col gutter>
                                <Row>
                                    <Col cols={12} gutter show={!store.Status.isOk} height={64}>
                                        <Button fullHeight fullWidth primary xnormal letterSpacing="wide" label="Descargar" loading={store.Status.isLoading} disabled={!store.canDownload} onClick={() => store.download()} />
                                    </Col>
                                    <Col cols={12} gutter show={store.Status.isOk} height={64}>
                                        <Button fullHeight fullWidth primary xnormal letterSpacing="wide" label="Restablecer" loading={store.Status.isLoading} onClick={() => store.reset()} />
                                    </Col>
                                    <Col cols={12} gutter show={!store.Status.isOk} height={64}>
                                        <Button fullHeight fullWidth outlined borderColor="surface-4" label="Restablecer" disabled={store.Status.isLoading} onClick={() => store.reset()} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Content>
            </Col>
        </Content>
    </>;
};